import RichtextSocialRecord from '~/components/richtext/RichtextSocialRecord.vue';

// @ts-ignore
export default function renderBlock({ record }) {
  if (record.__typename === 'RichtextSocialRecord') {
    return h(RichtextSocialRecord, { data: record });
  }
  return null;
}
